import { enableProdMode, ErrorHandler, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { environment } from './environments/environment';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from './app/auth/auth.interceptor';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { RumErrorHandler } from './app/shared/services/analytics/rum-error-handler';
import { WeightService } from './app/datatools-settings/weight-table/weight.service';
import { DuplicateService } from './app/duplikit/duplicate.service';
import { EventStreamService } from './app/duplikit/event-stream/event-stream.service';
import { DataCleanerService } from './app/data-cleaner/data-cleaner.service';
import { PreviousSearchesBurgerService } from './app/data-cleaner/previous-searches-burger/previous-searches-burger.service';
import { CandidateOptionsService } from './app/data-cleaner/candidate-options/candidate-options.service';
import { ConfirmationDialogService } from './app/data-cleaner/confirmation-dialog/confirmation-dialog.service';
import { HamburgerService } from './app/header/hamburger/hamburger.service';
import { HeaderServiceDirective } from './app/header/header.service';
import { DuplikitOptionsService } from './app/datatools-settings/duplikit-options/duplikit-options.service';
import { AdminService } from './app/admin/admin.service';
import { CookieService } from 'ngx-cookie-service';
import { DuplikitMergeService } from './app/shared/services/duplikit-merge.service';
import { UtilsService } from './app/shared/services/utils.service';
import { ProviderFactory } from './app/data-rules/lib/provider-factory';
import { LoadingSnackbarService } from './app/shared/services/loading-snackbar.service';
import { MasterIdentificationService } from './app/datatools-settings/master-identification-options/master-identification.service';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { AppRoutingModule } from './app/app-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatIconModule } from '@angular/material/icon';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatPaginatorModule } from '@angular/material/paginator';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatDividerModule } from '@angular/material/divider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(), importProvidersFrom(BrowserModule, FormsModule, MatMenuModule, MatButtonModule, MatButtonToggleModule, MatSelectModule, MatInputModule, MatDatepickerModule, MatMomentDateModule, HttpClientModule, AppRoutingModule, NgbModule, // TODO: can be removed, would want to undergo thorough testing before doing so.
        ReactiveFormsModule, MatDialogModule, MatIconModule, MatSelectModule, MatExpansionModule, MatChipsModule, MatTooltipModule, MatTableModule, MatSortModule, MatAutocompleteModule, MatPaginatorModule, NgxSkeletonLoaderModule, DragDropModule, MatSlideToggleModule, MatRadioModule, MatDividerModule, MatCheckboxModule),
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        { provide: MAT_DIALOG_DATA, useValue: {} },
        { provide: MatDialogRef, useValue: {} },
        {
            provide: ErrorHandler,
            useClass: RumErrorHandler
        },
        WeightService,
        DuplicateService,
        EventStreamService,
        DataCleanerService,
        PreviousSearchesBurgerService,
        CandidateOptionsService,
        ConfirmationDialogService,
        HamburgerService,
        HeaderServiceDirective,
        DuplikitOptionsService,
        AdminService,
        CookieService,
        DuplikitMergeService,
        UtilsService,
        ProviderFactory,
        LoadingSnackbarService,
        MasterIdentificationService,
        provideAnimations(),
    ]
})
  .catch(err => console.error(err));
